import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-wizard', 'completedStep', 'Completed step');
Labels.set('ui-wizard', 'next', 'Continue');
Labels.set('ui-wizard', 'back', 'Back');
Labels.set('ui-wizard', 'cancel', 'Cancel');
